export default "//static.tradera.net/touchweb/static/output/images/multicolor.3228e9ab.svg";